module.exports = __webpack_public_path__ + "static/media/E2.d676490b.png";